import {createSlice} from '@reduxjs/toolkit'
import {Keys} from "../../common/constants";

interface iDynamicState {
    company?: any
    configuration?: any
}

const initialState: iDynamicState = {
    company: null,
    configuration: null
}
export const dynamicLocalStoreKey = Keys.DYNAMIC
export const dynamicReducer: any = createSlice({
    name: dynamicLocalStoreKey,
    initialState,
    reducers: {
        getDynamicVariableFromLocalStore: (state?: any) => {
            const data = JSON.parse(localStorage.getItem(dynamicLocalStoreKey) || '{}');

            Object.keys(data).forEach(key => state[key] = data[key])
        },
        setDynamicVariables: (state: any, action) => {
            Object.keys(action.payload).forEach(key => state[key] = action.payload[key])
            localStorage.setItem(dynamicLocalStoreKey, JSON.stringify(state));
        }
    }
})

// Action creators are generated for each case reducer function
export const {
    setDynamicVariables,
    getDynamicVariableFromLocalStore
} = dynamicReducer.actions

export default dynamicReducer.reducer
